import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["className", "tooltipClassName", "tooltip", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React from 'react';
import { ButtonV2 as Button } from '@/components/Button';
import Tooltip from '@/components/Tooltip';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ShareTitle = _ref => {
  let {
    className = '',
    src,
    alt,
    heading,
    primary,
    PrimaryIcon,
    primaryTooltip = '',
    primaryDisabled = false,
    secondary,
    SecondaryIcon,
    secondaryTooltip = '',
    secondaryDisabled = false,
    onClick = () => undefined,
    onSecondary = () => undefined
  } = _ref;
  return /*#__PURE__*/_jsxs("li", {
    className: clsx(styles.container, className),
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.poster,
      children: /*#__PURE__*/_jsx("img", {
        src: src,
        alt: alt,
        loading: "lazy"
      })
    }), /*#__PURE__*/_jsxs("footer", {
      className: styles.footer,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.footer__secondary,
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.heading,
          children: heading
        }), secondary ? /*#__PURE__*/_jsx(TileButton, _objectSpread(_objectSpread(_objectSpread({
          onClick: onSecondary,
          size: "small",
          variant: "gray",
          disabled: secondaryDisabled
        }, secondaryTooltip && {
          tooltip: secondaryTooltip
        }), SecondaryIcon && {
          leftIcon: SecondaryIcon
        }), {}, {
          children: secondary
        })) : /*#__PURE__*/_jsx(_Fragment, {})]
      }), /*#__PURE__*/_jsx(TileButton, _objectSpread(_objectSpread(_objectSpread({
        className: primaryTooltip ? '' : styles.footer__primary,
        tooltipClassName: primaryTooltip ? styles.footer__primary : '',
        onClick: onClick,
        size: "large",
        variant: "primary",
        disabled: primaryDisabled
      }, primaryTooltip && {
        tooltip: primaryTooltip
      }), PrimaryIcon && {
        leftIcon: PrimaryIcon
      }), {}, {
        children: primary
      }))]
    })]
  });
};

export default ShareTitle;

// Add optional tooltip wrapper around a button
const TileButton = _ref2 => {
  let {
    className = '',
    tooltipClassName = '',
    tooltip,
    children
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded);

  return tooltip ? /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      placement: "bottom",
      className: tooltipClassName,
      content: tooltip,
      children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
        className: className
      }, props), {}, {
        children: children
      }))
    })
  }) : /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
    className: className
  }, props), {}, {
    children: children
  }));
};